import api from "../index"
import { apiTags } from "../tags"

const profileApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPendingProfileUpdateRequest: build.query({
      query: () => ({
        url: `/profile/pending/request`,
        method: "GET",
      }),
      providesTags: (res, err, arg) => [apiTags.updateProfile],
    }),
    saveUpdateSteps: build.mutation({
      query: (body) => ({
        url: `/profile/update/save/steps`,
        method: "POST",
        body,
      }),
      invalidatesTags: (res, err, arg) => {
        if (!err) {
          return [apiTags.updateProfile]
        }
        return []
      },
    }),
    getOtpPhoneVerificationProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/phone/get_otp`,
        method: "POST",
        body,
      }),
    }),
    verifyOtpPhoneVerificationProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/phone/verify_otp`,
        method: "POST",
        body,
      }),
    }),
    getOtpEmailVerificationProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/email/get_otp`,
        method: "POST",
        body,
      }),
    }),
    verifyOtpEmailVerificationProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/email/verify_otp`,
        method: "POST",
        body,
      }),
    }),
    updateBankDetailsProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/bank/details`,
        method: "POST",
        body,
      }),
    }),
    fetchBankDetailsProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/bank/fetch`,
        method: "POST",
        body,
      }),
    }),
    updateBusinessSignatoryDetailsProfile: build.mutation({
      query: (body) => ({
        url: `/profile/update/business/signatory`,
        method: "POST",
        body,
      }),
    }),
    uploadSignatureValidationProfile: build.mutation({
      query: (body) => ({
        url: `/profile/upload/signature`,
        method: "POST",
        body,
      }),
    }),
    uploadAuthorityLetterProfile: build.mutation({
      query: (body) => ({
        url: `/profile/upload/authority/letter`,
        method: "POST",
        body,
      }),
    }),
    businessDetailsManuallyProfile: build.mutation({
      query: (body) => ({
        url: `/profile/save/company/details`,
        method: "POST",
        body,
      }),
    }),
    storeAdditionalDetailsProfile: build.mutation({
      query: (body) => ({
        url: `/profile/additional/details`,
        method: "POST",
        body,
      }),
    }),
    storeBusinessAdditionalDetailsProfile: build.mutation({
      query: (body) => ({
        url: `/profile/business/additional/details`,
        method: "POST",
        body,
      }),
    }),
    kycFinalSubmissionProfile: build.mutation({
      query: (body) => ({
        url: `/profile/final/submission`,
        method: "POST",
        body,
      }),
      invalidatesTags: (res, err, arg) => {
        if (!err) {
          return [apiTags.updateProfile]
        }
        return []
      },
    }),
    getProfileUpdateRequests: build.query({
      query: (params) => ({
        url: `/profile/get/updates/requests`,
        method: "get",
        params,
      }),
    }),

    getProfileUpdateRequestsView: build.query({
      query: ({ id, ...params }) => ({
        url: `/profile/get/updates/requests/view/${id}`,
        method: "POST",
        body: params,
      }),
    }),

    getProfileUpdateRequestsApprove: build.mutation({
      query: ({ id }) => ({
        url: `/profile/updates/requests/approve/${id}`,
        method: "GET",
      }),
    }),
    getProfileUpdateRequestsReject: build.mutation({
      query: (body) => ({
        url: `/profile/updates/requests/reject`,
        method: "PUT",
        body,
      }),
    }),
    getProfileDeletions: build.query({
      query: (params) => ({
        url: `/profile/get/account/deletions`,
        method: "get",
        params,
      }),
    }),
  }),
})

export const {
  useLazyGetPendingProfileUpdateRequestQuery,
  useSaveUpdateStepsMutation,
  useGetOtpPhoneVerificationProfileMutation,
  useVerifyOtpPhoneVerificationProfileMutation,
  useUpdateBankDetailsProfileMutation,
  useFetchBankDetailsProfileMutation,
  useGetOtpEmailVerificationProfileMutation,
  useVerifyOtpEmailVerificationProfileMutation,
  useUpdateBusinessSignatoryDetailsProfileMutation,
  useUploadSignatureValidationProfileMutation,
  useUploadAuthorityLetterProfileMutation,
  useBusinessDetailsManuallyProfileMutation,
  useStoreAdditionalDetailsProfileMutation,
  useStoreBusinessAdditionalDetailsProfileMutation,
  useKycFinalSubmissionProfileMutation,
  useLazyGetProfileUpdateRequestsQuery,
  useLazyGetProfileUpdateRequestsViewQuery,
  useGetProfileUpdateRequestsApproveMutation,
  useGetProfileUpdateRequestsRejectMutation,
  useLazyGetProfileDeletionsQuery,
} = profileApi
